const schemaDataUploads = {
  type: 'object',
  title: 'dataUploads',
  description: 'Upload data files.',
  properties: {
    type: { type: 'string', const: 'dataUploads' },
    uploadTypes: {
      type: 'array',
      description: 'List of upload types to show upload buttons for.',
      items: { type: 'string' },
    },
  },
  required: ['type'],
};

const schemaQuickAccess = {
  type: 'object',
  title: 'quickAccess',
  description: 'A set of buttons that open specific assets.',
  properties: {
    type: { type: 'string', const: 'quickAccess' },
    title: { type: 'string', description: 'Title of the section.' },
    elements: {
      type: 'array',
      items: {
        type: 'object',
      },
    },
  },
  required: ['type'],
};

const schemaSearchFilter = {
  type: 'object',
  title: 'searchFilter',
  description: 'The edit field where search text can be entered.',
  properties: {
    type: { type: 'string', const: 'searchFilter' },
    disableSearchBar: { type: 'boolean', description: 'If set to true, the search bar is not displayed' },
    disableTags: {
      type: 'boolean',
      description: 'If set to true, the set of tags to filter by asset type is not displayed',
    },
    tagOptions: {
      type: 'object',
      properties: {
        order: { type: 'string', description: 'Order of the label tags', enum: ['alphabetical', 'count'] },
      },
    },
    searchBarOptions: {
      type: 'object',
      properties: {
        label: { type: 'string', description: 'Placeholder text in the search bar.' },
      },
    },
  },
  required: ['type'],
};

const schemaAssetOverview = {
  type: 'object',
  title: 'assetOverview',
  description: 'The result set of assets.',
  properties: {
    type: { type: 'string', const: 'assetOverview' },
    sortBy: { type: 'string' },
    sortOptions: {
      type: 'array',
      items: {
        type: 'object',
        description: 'List of the available sort options',
        properties: {
          id: { type: 'string', description: 'Identifier of the sort option.' },
          assetInfoKey: { type: 'string', description: 'Identifier of the asset property to sort on.' },
          title: { type: 'string', description: 'Display name of the sort option.' },
          type: { type: 'string', description: 'Data type of the sortable values.' },
          reverse: { type: 'boolean', description: 'Sort direction.' },
        },
      },
    },
  },
  required: ['type'],
};

const schemaAssetDashboard = {
  type: 'object',
  title: 'assetDashboard',
  description: 'A dashboard for all assets in the organization.',
  properties: {
    type: { type: 'string', const: 'assetDashboard' },
    property_key: { type: 'string', description: 'Property of the asset containing the data context.' },
    onMissingContent: {
      type: 'object',
      description: 'specify behaviour in case the data context is not available',
      properties: {
        placeholder: { type: 'string', description: 'text to show instead of the dashboard.' },
        showError: {
          type: 'boolean',
          description: 'either show an error if the data is missing or show the placeholder.',
        },
      },
    },
  },
  required: ['type', 'property_key'],
};

const schemaStartPageView = {
  type: 'object',
  properties: {
    startPageElements: {
      type: 'array',
      description: 'List of all elements that appear in the entity view. These elements are displayed sequentially.',
      items: {
        anyOf: [schemaQuickAccess, schemaSearchFilter, schemaAssetOverview, schemaDataUploads, schemaAssetDashboard],
      },
    },
  },
  required: ['startPageElements'],
};

export default schemaStartPageView;
